import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useIsTextClamped } from './useIsTextClamped'

type Props = {
  name: string
  fontWeight?: number
}

/**
 * 列ヘッダーの質問名。固定幅のセル内で 2 行まで折り返し、超過分は…で省略する。
 * 省略が起きているときだけ、hover で全文の tooltip を出す。
 */
export const TableColumnHeaderName = ({ name, fontWeight = 700 }: Props) => {
  const { ref, isClamped } = useIsTextClamped(name)

  return (
    <Tooltip title={isClamped ? name : ''}>
      <Typography
        ref={ref}
        variant="body2"
        fontWeight={fontWeight}
        sx={{
          flex: '1 1 auto',
          minWidth: 0,
          textAlign: 'left',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          overflow: 'hidden',
          // 長い単語/URL でもセル幅で折り返せるようにする。
          overflowWrap: 'anywhere',
        }}
      >
        {name}
      </Typography>
    </Tooltip>
  )
}
